import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import classnames from 'classnames';
import { Button, Row, Col } from 'react-bootstrap';
import FileViewer from 'react-file-viewer';
import { Loading } from '..';

class DialogBox extends Component {
    constructor(props) {

        super(props)
        this.state={
            isPreview : props.isPreview,
            showBack: props.url?true:false,
        }
        this.handleClose = this.handleClose.bind(this);
    }
    
    handleClose() {
        this.props.handleHidePdf();
    }

    render() {
        const { show, title, isPreview,subtitle,url, custom_class, onHide } = this.props;

        return (
            <div>
            
           {<Modal show={show} dialogClassName={classnames(['custom-modal', custom_class])}  onHide={onHide}>
                <Modal.Header>
                    
                    <div className="close-glyph">
                        <span className="glyphicon glyphicon-remove" aria-hidden="true" onClick={onHide} />
                    </div>
                     <Modal.Title>{title}</Modal.Title>
                    <span className="modal-subtitle">{subtitle}</span>
                
                </Modal.Header>

                <Modal.Body> {this.props.children} </Modal.Body>
                   
        </Modal> }
        {/* {this.state.isPreview && !url && this.props.loading && <Loading classes="loading" /> } */}
         {this.props.isPreview && this.props.pdfStatus !=='failed' &&
             <Modal show={isPreview && this.props.pdfStatus !=='failed'} dialogClassName={classnames(['custom-modal-pdf','margin-top', custom_class])} onHide={this.handleClose}>  
            
             <Modal.Header className='modall-header '>
           <div className="close-glyph">
           {url&& <Button onClick={this.handleClose}>Back</Button>}
              </div>
           
       </Modal.Header>

        <Modal.Body className='modall-body'> 
       
        {!url && this.props.pdfStatus !=='failed' && <Loading classes="loading centre-position" />}
         {url && <FileViewer fileType={'pdf'} filePath={url}/>}  
        </Modal.Body>
        </Modal>}
        </div>
            
        );
    }
}

DialogBox.defaultProps = {
    show: false,
    title: 'Modal Title'
};

export default DialogBox;
